<template>
    <div class="container remove-padding-margin">
        <div class="fixed-judul fixed-top">
            <div class="row align-items-center set-row" style="border-bottom: 1px solid #F2F5F7">
                <div class="col-md-1 col-sm-1 col-1 remove-padding" @click="back">
                    <img src="../../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-10 col-sm-10 col-10 text-center remove-padding">
                    <div class="remove-margin font-16 font-colorcheck text-promo nomore">Workshop {{workshop.nama}}</div>
                </div>
                <div class="col-md-1 col-sm-1 col-1"></div>
            </div>
        </div>
        <main class="" id="detailsetprod">
            <div class="flex-100">
                <div class="flex-1">
                    <div class="mar-top-60"></div>
                    <div class="row remove-margin text-detailO" :data-toggle="validateAccess('workshop.update') && 'modal'" data-target="#modalEname">
                        <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                            <div class="font-14  mar-top-5 mar-bot-0 color-8080">
                                Nama Workshop
                            </div>
                            <div class="nomore">
                                {{workshop.nama}}
                            </div>
                        </div>
                        <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right" v-if="validateAccess('workshop.update')">
                            <span><i class="far fa-edit color-206CF" ></i></span>
                        </div>
                    </div>
                    <div class="row remove-margin text-detailO" :data-toggle="validateAccess('workshop.update') && 'modal'" data-target="#modalEtelp">
                        <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                            <div class="font-14  mar-top-5 mar-bot-0 color-8080">
                                Nomor Telpon Workshop
                            </div>
                            <div>
                                {{workshop.telp}}
                            </div>
                        </div>
                        <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right" v-if="validateAccess('workshop.update')">
                            <span><i class="far fa-edit color-206CF" ></i></span>
                        </div>
                    </div>
                    <div class="row remove-margin text-detailO" :data-toggle="validateAccess('workshop.update') && 'modal'" data-target="#modalEkota">
                        <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                            <h6 class="font-14  mar-top-5 mar-bot-0 color-8080">
                                Kota
                            </h6>
                            <h6>
                                {{workshop.kota}}
                            </h6>
                        </div>
                        <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right" v-if="validateAccess('workshop.update')">
                            <span><i class="far fa-edit color-206CF" ></i></span>
                        </div>
                    </div>
                    <div class="row remove-margin text-detailO" :data-toggle="validateAccess('workshop.update') && 'modal'" data-target="#modalEaddress">
                        <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                            <h6 class="font-14  mar-top-5 mar-bot-0 color-8080">
                                Alamat Lengkap
                            </h6>
                            <h6>
                                {{workshop.alamat}}
                            </h6>
                        </div>
                        <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right" v-if="validateAccess('workshop.update')">
                            <span><i class="far fa-edit color-206CF"></i></span>
                        </div>
                    </div>
                    <div class="pembatas remove-margin"></div>
                    <div class="row remove-margin text-detailO" @click="settahapan(workshop.idworkshop)">
	                    <div class="col-sm-6 col-md-6 col-lg-6 col-6 remove-padding-margin">
                            <h6 class="font-14 remove-margin font-colorcheck text-promo">
                                Proses Produksi
                            </h6>
		                    <div v-if="isidatatahapan > 0">
			                    <h6 class="font-14 remove-margin color-80808">
				                    {{isidatatahapan}} Tahapan Workshop
			                    </h6>
		                    </div>
		                    <div v-else>
			                    <h6 class="font-14 remove-margin color-80808">
				                    Dilakukan dilokasi lain
			                    </h6>
		                    </div>
                        </div>
                        <div v-if="isidatatahapan > 0" class="col-sm-6 col-md-6 col-lg-6 col-6 text-right remove-padding">
                            <span><img class="mar-top-5" src="../../../assets/icons/chevron-right1.svg" alt=""></span>
                        </div>

                    </div>
                    <div class="pembatas remove-margin"></div>
                    <div class="row remove-margin text-detailO" v-if="validateAccess('workshop.delete')" data-toggle="modal" data-target="#modalDelete">
                        <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin">
                            <img src="../../../assets/icons/trash-2.svg" alt="">
                        </div>
                        <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">Sembunyikan Workshop</div>
                    </div>
                    <div class="modal fade" id="modalDelete" role="dialog">
                        <div class="modal-dialog modal-lg  bani-modal">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <div class="nav-btn kiri"></div>
                                    <h5 class="navbar-title text-center">Sembunyikan Workshop?</h5>
                                    <div class="nav-btn kanan tutup">
                                        <img src="../../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <div class="remove-margin">Semua data keuangan akan tetap tersimpan & ditampilkan.
                                        Yakin ingin <b>Menyembunyikan</b> workhsop <b>{{workshop.nama }}??</b>
                                    </div>

                                    <div class=" m-t-20">Anda tetap bisa mengaktifkannya pada halaman daftar workshop.
                                    </div>
                                </div>
                                <div class="modal-footer remove-margin">
                                    <div class="button-wrapper w-limit w-100">
                                        <div class="btn btn-outline-primary btn-long" @click="delworkshop"
                                             data-dismiss="modal">Ya, Sembunyikan</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade" id="modalEname" role="dialog">
                        <div class="modal-dialog modal-lg  bani-modal">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <div class="nav-btn kiri"></div>
                                    <h5 class="navbar-title text-center">Ubah Nama Workshop</h5>
                                    <div class="nav-btn kanan tutup">
                                        <img src="../../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <form action="">
                                        <div class="form-group">
                                            <label class="remove-margin font-14 color-8080" for="namaCworkshop">Nama
                                                Workshop </label>
                                            <input type="text" class="form-control inputs" id="namaCworkshop"
                                                   v-model="nama_Workshop_detail">
	                                        <ErrorMessage class="error" label="Nama Workshop" :validation="$v.nama_Workshop_detail"></ErrorMessage>
                                        </div>
                                    </form>
                                </div>
                                <div class="modal-footer">
                                    <div class="button-wrapper w-limit w-100">
                                        <div class="btn btn-outline-primary btn-long" @click="updateName"
                                             >Simpan</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade" id="modalEtelp" role="dialog">
                        <div class="modal-dialog modal-lg  bani-modal">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <div class="nav-btn kiri"></div>
                                    <h5 class="navbar-title text-center">Ubah Nomor Telphone Workshop</h5>
                                    <div class="nav-btn kanan tutup">
                                        <img src="../../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <form action="">
                                        <div class="form-group">
                                            <label class="remove-margin font-14 color-8080" for="telpoutlet">Telphone
                                                Workshop</label>
                                            <div class="input-group remove-padding mod">
                                              <vue-country-code
                                                  @onSelect="onSelect" :preferredCountries="['id', 'my', 'bn']">
                                              </vue-country-code>
                                              <input type="text" class="form-control inputs" id="telpoutlet"
                                                   v-model="nomor_workshop_detail" v-on:keyup="nomorWaOnkeyup">
                                            </div>
                                            <ErrorMessage class="error" label="Nomor Telephone" :validation="$v.nomor_workshop_detail"></ErrorMessage>
                                        </div>
                                    </form>
                                </div>
                                <div class="modal-footer">
                                    <div class="button-wrapper w-limit w-100">
                                        <div class="btn btn-outline-primary btn-long" @click="updateTelp"
                                             >Simpan</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade" id="modalEkota" role="dialog" aria-hidden="true">
                        <div class="modal-dialog modal-lg  bani-modal">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <div class="nav-btn kiri"></div>
                                    <h5 class="navbar-title text-center">Ubah Kota Outlet</h5>
                                    <div class="nav-btn kanan tutup">
                                        <img src="../../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                    </div>
                                </div>
                                <div class="modal-body set-modal-body">
                                    <div class="mod">
                                    <label for="select2" class="p-x-20 remove-margin font-14 color-8080">Kota Outlet</label>
                                    <Select2   id="select2" class="p-x-20"
                                             v-model="selectedkota" :options="optionskota"
                                             :settings="{ placeholder: 'Pilih Kota' }"
                                             @change="myChangeEvent($event)" @select="mySelectEvent"/>
	                                <ErrorMessage class="error" label="Nomor Telephone" :validation="$v.selectedkota"></ErrorMessage>
                                </div>
                                </div>
                                <div class="modal-footer">
                                    <div class="button-wrapper w-limit w-100">
                                        <div class="btn btn-outline-primary btn-long" @click="updateKota"
                                             >Simpan</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade" id="modalEaddress" role="dialog">
                        <div class="modal-dialog modal-lg  bani-modal">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <div class="nav-btn kiri"></div>
                                    <h5 class="navbar-title text-center">Ubah Alamat Outlet</h5>
                                    <div class="nav-btn kanan tutup">
                                        <img src="../../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <form action="">
                                        <div class="form-group">
                                            <label class="remove-margin font-14 color-8080" for="addressDworkshop">Alamat Outlet</label>
                                            <input type="text" class="form-control inputs" id="addressDworkshop" v-model="alamat_workshop_detail">
	                                        <ErrorMessage class="error" label="Alamat" :validation="$v.alamat_workshop_detail"></ErrorMessage>
                                        </div>
                                    </form>
                                </div>
                                <div class="modal-footer">
                                    <div class="button-wrapper w-limit w-100">
                                        <div class="btn btn-outline-primary btn-long" @click="updateAddress"
                                             >Simpan</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade" id="modalcantdel" role="dialog">
                        <div class="modal-dialog modal-lg  bani-modal">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <div class="nav-btn kiri"></div>
                                    <h5 class="navbar-title text-center">Sembunyikan Workshop </h5>
                                    <div class="nav-btn kanan tutup">
                                        <img src="../../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <div id="textmodalfalse"><br></div>
                                    <div class="mar-top-20">Pisahkan dari outlet sebelum menyembunyikan workshop.</div>
                                    <div class="mar-top-8 color-206CF" @click="goToOutlet">
	                                    <b>Buka Detail Outlet 🡒</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
	    <TahapanDetailSetProd v-bind:class="{hidesection:!istahapandetailsetprod}"
	                          v-bind:setidworkshoptahapandetail="workshop.idworkshop"
	                          v-on:gotodetailworkshop="gotodetailworkshopdata"
	                          ref="tahapandetailsetprod"/>
    </div>
</template>

<script>
    import Select2 from 'v-select2-component';
    import TahapanDetailSetProd from "@/components/production/TahapanDetailSetProd";
    import ErrorMessage from "@/component-items/ErrorMessage";
    import {maxLength, minLength, required} from "vuelidate/lib/validators";
    
    export default {
        name: "DetailWorkshop",
        components: {Select2, TahapanDetailSetProd, ErrorMessage},
        props: ["datalistworkshop"],
        data(){
            return{
                idoutlet: '',
                workshop: {},
                selectedkota: '1',
                optionskota: [],
                isClicked:true,
                nama_Workshop_detail:'',
                telpCode: '',
                nomor_workshop_detail:'',
                alamat_workshop_detail:'',
                text_kota_Detail:'',
                id_kota_Detail:'',
	            isidatatahapan: 0,
	            istahapandetailsetprod:false,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
	            
	            rejectDelete: null,
	            popupData: {
                	type: "",
		            message: "",
		            errorException: null,
	            }
            }
        },
	    validations: {
		    nama_Workshop_detail: {
		    	required,
			    minLength: minLength(2),
		    },
		    nomor_workshop_detail: {
		    	required,
			    minLength: minLength(8),
			    maxLength: maxLength(15),
		    },
		    selectedkota: {
		    	required,
		    },
		    alamat_workshop_detail: {
		    	required,
			    minLength: minLength(2),
		    }
	    },
        mounted(){
            this.idworkshop = this.$route.params.idworkshop;
            this.getkota();
            this.getDetailWorkshop()
            this.smartTrackingView("detail_workshop");

        },
        methods:{
          onSelect({name, iso2, dialCode}) {
            this.telpCode=dialCode
          },
	        gotodetailworkshopdata(idworkshop){
		        this.istahapandetailsetprod=false;
		        $('#detailsetprod').show();
		        this.getDetailWorkshop(idworkshop);
		        this.getkota(idworkshop);
	        },

            async getDetailWorkshop() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner')
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_workshop_meta?idworkshop=' + this.datalistworkshop.idworkshop + '&idowner=' + idowner, this.requestHeaders)
	                this.isidatatahapan = response.data.data.tahapan.length;
	                this.workshop = response.data.data.workshop;
                    //this.nomor_workshop_detail = this.workshop.telp;
                    this.nama_Workshop_detail = this.workshop.nama;
                    this.selectedkota = this.workshop.kota_id;
                    this.alamat_workshop_detail = this.workshop.alamat;
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },


            back(){
                this.$emit('gotolist', 'workshop')
            },
            settahapan(idworkshop){
                this.smartTrackingClick("edit_tahapan_workshop");

                if (this.isidatatahapan > 0) {
		            // this.$emit('TahapanWorkshop',idworkshop)
		            this.istahapandetailsetprod = true;
		            $('#detailsetprod').hide();
		            this.$refs.tahapandetailsetprod.getChecklistdetailsetprod(idworkshop);
		            this.$refs.tahapandetailsetprod.getTahapandetailsetprod();

                }

            },

            // GetDetail(){
            //   this.$emit('GetDetailWorkshop')
            // },

            gotodetailoutlet(){
              this.$emit('gotodetailoutlet')
            },

            async updateName(){
	        	if (this.$v.nama_Workshop_detail.$invalid) {
			        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
	        		return
		        }
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner');
                    const updatedata = new FormData();
                    updatedata.append('fieldValue', this.nama_Workshop_detail);
                    updatedata.append('fieldName', 'nama')
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_workshop?idowner=' + idowner + "&idworkshop=" + this.datalistworkshop.idworkshop, updatedata, this.requestHeaders)
                    $('#loadingPage').hide()
                    $('#loadingPage').removeClass('overlayLoading');
                    this.$toast.success(response.data.msg)
                    this.getDetailWorkshop();
                    $("#modalEname").modal("hide");
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },

            async updateTelp(){
	        	if (this.$v.nomor_workshop_detail.$invalid) {
			        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
			        return
		        }
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner')
                    const updatedata = new FormData()
                    updatedata.append('fieldValue', this.telpCode + this.nomor_workshop_detail)
                    updatedata.append('fieldName', 'telp')
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_workshop?idowner=' + idowner + "&idworkshop=" + this.datalistworkshop.idworkshop, updatedata, this.requestHeaders)
                    $('#loadingPage').hide()
                    $('#loadingPage').removeClass('overlayLoading');
                    this.$toast.success(response.data.msg)
                    this.getDetailWorkshop();
                    $("#modalEtelp").modal("hide")
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },

            async updateAddress(){
	        	if (this.$v.alamat_workshop_detail.$invalid) {
			        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
			        return
		        }
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner');
                    const updatedata = new FormData();
                    updatedata.append('fieldValue', this.alamat_workshop_detail);
                    updatedata.append('fieldName', 'alamat');
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_workshop?idowner=' + idowner + "&idworkshop=" + this.datalistworkshop.idworkshop, updatedata, this.requestHeaders)
                    $('#loadingPage').removeClass('overlayLoading');
                    this.$toast.success(response.data.msg)
                    $('#loadingPage').hide()
                    this.getDetailWorkshop();
                    $("#modalEaddress").modal("hide");
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },

            async updateKota(){
	        	if (this.$v.selectedkota.$invalid) {
			        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
	        		return
		        }
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner')
                    const updatedata = new FormData()
                    updatedata.append('fieldValue', this.workshop.kota_id);
                    updatedata.append('fieldName', 'kota_id')
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_workshop?idowner=' + idowner + "&idworkshop=" + this.datalistworkshop.idworkshop, updatedata, this.requestHeaders)

                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide();
                    this.$toast.success(response.data.msg)
                    this.getDetailWorkshop();
                    $("#modalEkota").modal("hide")
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },

            async delworkshop(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
              try {
                  var idowner = localStorage.getItem('idowner');
                  const delworkshop =new FormData()
                  const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/delete_workshop?idowner=' + idowner + "&idworkshop=" + this.datalistworkshop.idworkshop, delworkshop, this.requestHeaders)
                  if(response.data.status===true){
	                  $('#loadingPage').removeClass('overlayLoading');
	                  $('#loadingPage').hide();
	                  
	                  this.popupData.type = "success"
	                  this.popupData.message = "Workshop " + response.data.data.nama_workshop + " berhasil disembunyikan"
	                  this.$emit("showPopup", this.popupData)
	
	                  this.getDetailWorkshop();
	                  this.back();
                  }else{
                      $('#loadingPage').removeClass('overlayLoading');
                      $('#loadingPage').hide();
                      $('#modalcantdel').modal('show');
                      $('#textmodalfalse').html(response.data.msg);
                      this.rejectDelete = response.data.data
                  }
              }  catch (e) {
	              $('#loadingPage').removeClass('overlayLoading');
	              $('#loadingPage').hide()
	
	              this.popupData.type = "success"
	              this.popupData.errorException = e
	              this.$emit("showPopup", this.popupData)
              }
            },

            myChangeEvent(val) {
                this.myValue = val
            },
            mySelectEvent(e) {
                this.workshop.kota = e.text;
                this.workshop.kota_id = e.id;
            },

            async getkota() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/kota_meta',this.requestHeaders)
                    if (response.status === 200) {
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide()
                        var rawkota = response.data.data;
                        this.optionskota.push({id: "", text: "Pilih Kota"})
                        for (var i = 0; i < rawkota.length; i++) {
                            this.optionskota.push({id: rawkota[i].id, text: rawkota[i].nama})
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }

            },

            nomorWaOnkeyup(event) {
                var phoneField = event.target.value;
                var tel = phoneField.substring(5, 20);
                var codeCountry = phoneField.substring(0, 2);
                var firstTel = phoneField.substring(2, 20);
                var output

              if (frstCar == 0) {
                output = firstTel
              } else if (secCar == this.telpCode) {
                output = secTel
              } else {
                output = thrdcar
              }
              var number = output.replace(/[^0-9]+/, '');

              var charLenght = output.length;
                if (charLenght >= 10 && charLenght <= 14) {
                    // $('#buttonSendOtp').prop('disabled', false);
                } else {
                    // $('#buttonSendOtp').prop('disabled', true);
                }
                this.nomor_workshop_detail = output;
            },
	        goToOutlet() {
		        $("#modalcantdel").modal("hide");
            	setTimeout(() => {
		            this.idoutlet = this.rejectDelete.id_outlet
		            this.$emit("goToOutlet", this.idoutlet)
	            }, 50)
	        }
        }
    }
</script>

<style scoped>
    .text-detailO{
        border-bottom: 1px solid #EDEDED;
        padding: 12px 20px;

    }

    .nomore {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .hidesection {
	    display: none;
    }
</style>